// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2facB","actionsCol":"EnrolledClinics_actionsCol__-DKxd"};